module.exports = __webpack_public_path__ + "img/icon_user.fc8292fc.png";